import React from 'react'
import studentNameFrame from '../../../assets/early/svg/StudentNameFrame.svg'
import { EMOTION_ANIMAL_BACKGROUND_COLOR } from '../constants/Constants'
import { AnimalImages } from '../../../assets/early/animals/AnimalImagesPNG'
import '../../../styles/early/earlyMotion.css'

function StudentButton({ animal = 'tiger', emotion: studentEmotion = 'happy', student = {}, style = {}, onClick = () => {}, smaller = false, disabled = false }) {
    // 0,79885057
    const width = smaller ? 111 : 139
    const height = smaller ? 120 : 149
    const placeholderWidth = smaller ? 116 : 146
    const placeholderHeight = smaller ? 47 : 59
    const bottom = smaller ? -43 : -54
    const emotion = !!studentEmotion ? studentEmotion : 'ok'
    return (
        <button
            className="rounded-[25px]  border-[7px] border-[#FDDF6D] relative em-tap em-tap--card"
            style={{ backgroundColor: EMOTION_ANIMAL_BACKGROUND_COLOR[emotion], minWidth: width, width: width, height: height, ...style }}
            onClick={() => onClick(student)}
            disabled={disabled}
        >
            <img src={AnimalImages[animal ?? 'tiger'][emotion]} alt={animal} className="w-full h-full object-cover rounded-[25px]" />
            <div
                className="absolute -left-[10px] bg-no-repeat bg-contain flex flex-row items-center justify-between pl-[15px] pr-[11px]"
                style={{ backgroundImage: `url(${studentNameFrame})`, width: placeholderWidth, height: placeholderHeight, bottom: bottom }}
            >
                <p className="text-[16px] leading-5 font-bold text-[#FFFFFF] text-left overflow-hidden text-ellipsis line-clamp-3">
                    {student.first_name} {student.last_name}
                </p>
            </div>
        </button>
    )
}

export default StudentButton
